export const CHAT_GRADIENT_START = '#041282'
export const CHAT_GRADIENT_MIDDLE = '#414F8C'
export const CHAT_GRADIENT_END = '#A6607A'
export const CHAT_ON_GRADIENT = '#E2E2E2'
export const CHAT_ON_GRADIENT_DIVIDER = '#B0BDC2'
